module.exports = __webpack_public_path__ + "img/6.2bcca983.jpg";